import React, { Component } from "react";
import { connect } from "react-redux";
import { 
  setHomeValue,
  increaseStepByOne
} from "../../../actions";
import { home, options } from "../../../operations";

import { Body } from '../../Common/Form';
import Text from '../../Common/Form/Text';
import SelectedAnswers from './SelectedAnswers';
import Loader from '../../Common/Loader';
import { 
  numberWithDots,
  compareValues
} from "../../../helpers";

import theftIcon from '../../../assets/icons/hogar/ic_robo.png';

class HogarForm_4 extends Component {

  constructor(props) {
    super(props);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount () {
    const { 
      cleanTheftSelected
    } = this.props;
    cleanTheftSelected();
  }

  getContent() {

    const {
      isLoading,
      theftOptions,
      onOptionSelect,
      getTheftOptions,
    } = this.props;

    return (
      <div>
        <SelectedAnswers />
        <div className="SkyBlue-box">
          <p className="SkyBlue-text SkyBlue-text-bold"> Protección para tus COSAS frente a un INCENDIO o ROBO </p>
          <p className="SkyBlue-text"> Ahora definamos cuál es el valor total de las cosas en el interior de tu hogar que te gustaría cubrir. </p>
        </div>
        <div className="OptionInfo-container">
          <img className="OptionInfo-icon" src={theftIcon} alt="info" />
          <div className="OptionInfo-text">
            Para definirlo, tenés que calcular la suma máxima que querés recibir por la perdida o daño de tus cosas.
          </div>
        </div>
        { isLoading ? <Loader message='' /> : (
          (theftOptions && theftOptions.length > 0 &&
            <div className="OptionInfo-options-container">
              {theftOptions.sort(compareValues('Value')).map((theft) => {
                const amountText = 'U$S ' + numberWithDots(theft.Value);
                return (
                  <div
                    key={theft.Code}
                    className="OptionInfo-options-option"
                    onClick={() => { onOptionSelect(theft) }}>
                    {amountText}
                  </div>
                );
              })}
            </div>
          ) ||
          ((!theftOptions || !theftOptions.length) &&
            <>
              <div className="OptionInfo-text OptionInfo-center"> Las opciones no cargaron correctamente. </div>
              <div
                style={{'display': 'inline-flex'}}
                className="OptionInfo-options-option"
                onClick={getTheftOptions}>
                Volver a cargar
              </div>
            </>
          )
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        <Body columnContent={this.getContent} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    theftOptions: state.home.theftOptions,
    isLoading: state.steps.isInnerLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onOptionSelect: (theft) => {
      dispatch(setHomeValue('theftSelected', theft));
      dispatch(home.getQuotation());
      dispatch(increaseStepByOne());
    },
    cleanTheftSelected: () => {
      dispatch(setHomeValue('theftSelected', null));
    },
    getTheftOptions: () => {
      dispatch(options.getTheftOptions());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HogarForm_4);